import { ICON as tutorial } from '../Tutorial';
export interface LogicManagerModule {
    id: number;
    modal?: string;
    name: string;
    slug: string;
    icon: string;
}

export function getModuleByProp(prop: string, value: any) {
    const module = LOGICMANAGER_MODULES.find(module => {
        if (module[prop] === value) {
            return module;
        }
    });

    return (
        module ??
        ({
            id: 0,
            name: 'Error',
            icon: tutorial,
            slug: 'Error'
        } as LogicManagerModule)
    );
}

export const LOGICMANAGER_MODULES: LogicManagerModule[] = [
    {
        id: 13,
        name: 'Pré-Logic',
        icon: tutorial,
        slug: 'tutorial'
    },
];
